export default __webpack_public_path__ + "static/media/Bias-HandBook-Download-Space.3f961487.png";